import { Link } from 'react-router-dom'
import { BrowserView, MobileView } from 'react-device-detect'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faGooglePlus, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { Fade } from 'react-awesome-reveal'
import '../../styles/Footer/Footer.css'

function Footer() {

    // function signOut() {

    //     axios.get(process.env.REACT_APP_API_URL + 'user/signOut', {}, { withCredentials: true }).then(() => {
    //         dispatch(deleteStoreUser())
    //         window.scrollTo({ top: 0, behavior: 'instant' })
    //         navigate('/')
    //     }).catch(() => {
    //         dispatch(deleteStoreUser())
    //         window.scrollTo({ top: 0, behavior: 'instant' })
    //         navigate('/')
    //     })

    // }

    return (

        <>
            <BrowserView>
                <div className='footer'>
                    <Fade>
                        <Row>
                            <Col>
                                <div className='footerTitle'>Donation</div>
                                <Link to='/donation' className='footerLink'>Faire un don</Link>
                                <div className='footerTitle'>Confidentialité</div>
                                <Link to='/CGU' className='footerLink'>Termes et conditions</Link>
                            </Col>
                            <Col>
                                <div className='footerTitle'>À propos</div>
                                <Link to='/%C3%A0-propos/notre-équipe' className='footerLink'>Notre équipe</Link>
                                <Link to='/%C3%A0-propos/qui-sommes-nous' className='footerLink'>Qui sommes-nous ?</Link>
                                <Link to='/%C3%A0-propos/notre-fonctionnement' className='footerLink'>Notre fonctionnement</Link>
                            </Col>
                            <Col>
                                <div className='footerTitle'>Réseau sociaux</div>
                                <div className='footerSocialNetwork'>
                                    <FontAwesomeIcon icon={faFacebook} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faXTwitter} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faInstagram} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faGooglePlus} className='footerSocialNetworkIcon' />
                                </div>
                            </Col>
                            {/* <Col>
                                <div className='footerTitle'>Administration</div>
                                <div className='footerSignInButtonLink'>
                                    {location.pathname === '/administration' ?
                                        <Button theme={'light'} icon={<FontAwesomeIcon icon={faArrowRightToBracket} />} text={"Déconnexion"} rounded={true} onClick={() => signOut()} />
                                        :
                                        <Button theme={'light'} icon={<FontAwesomeIcon icon={faArrowRightToBracket} />} text={"Connexion"} rounded={true} onClick={() => navigate('/administration/connexion')} />
                                    }
                                </div>
                            </Col> */}
                        </Row>
                    </Fade>
                </div>
            </BrowserView>

            <MobileView>
                <div className='footerMobile'>
                    <Fade>
                        <Row>
                            <Col>
                                <div className='footerTitle'>Donation</div>
                                <Link to='/donation' className='footerLink'>Faire un don</Link>
                                <div className='footerTitle'>Confidentialité</div>
                                <Link to='/CGU' className='footerLink'>Termes et conditions</Link>
                            </Col>
                            <Col>
                                <div className='footerTitle'>Réseau sociaux</div>
                                <div className='footerSocialNetwork'>
                                    <FontAwesomeIcon icon={faFacebook} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faXTwitter} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faInstagram} className='footerSocialNetworkIcon' />
                                    <FontAwesomeIcon icon={faGooglePlus} className='footerSocialNetworkIcon' />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className='footerTitle'>À propos</div>
                                <Link to='/%C3%A0-propos/notre-équipe' className='footerLink'>Notre équipe</Link>
                                <Link to='/%C3%A0-propos/qui-sommes-nous' className='footerLink'>Qui sommes-nous ?</Link>
                                <Link to='/%C3%A0-propos/notre-fonctionnement' className='footerLink'>Notre fonctionnement</Link>
                            </Col>
                            {/* <Col>
                                <div className='footerTitle'>Administration</div>
                                <div className='footerSignInButtonLink'>
                                    <Button theme={'light'} icon={<FontAwesomeIcon icon={faArrowRightToBracket} />} text={"Connexion"} rounded={true} onClick={() => navigate('/administration/connexion')} />
                                </div>
                            </Col> */}
                        </Row>
                    </Fade>
                </div>
            </MobileView>
        </>


    )

}

export default Footer
